(function () {
  function goToCart() {
    if (window.location.pathname === '/cart') return;
    document.documentElement.setAttribute('data-una-opening-stable-cart', String(Date.now()));
    window.location.assign('/cart');
  }

  function restoreBuyNowButtons() {
    document.querySelectorAll('[data-una-buy-now-loading="true"]').forEach(function (button) {
      var label = button.querySelector('[data-una-buy-now-text]');
      var originalText = button.getAttribute('data-una-buy-now-original-text') || 'Finalizar compra';

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.removeAttribute('data-una-buy-now-loading');
      button.removeAttribute('data-una-buy-now-original-text');
      if (label) label.textContent = originalText;
    });
  }

  function goToCheckout(button) {
    var form = button && button.closest && button.closest('form[action*="/cart/add"]');
    var addButton = form && form.querySelector('[data-add-to-cart]');

    if (!form || button.disabled || button.getAttribute('data-una-buy-now-loading') === 'true') return;
    if (addButton && (addButton.disabled || addButton.getAttribute('aria-disabled') === 'true')) return;

    var label = button.querySelector('[data-una-buy-now-text]');
    var originalText = label ? label.textContent : button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('data-una-buy-now-loading', 'true');
    button.setAttribute('data-una-buy-now-original-text', originalText);
    if (label) label.textContent = 'Abrindo checkout...';

    Promise.resolve(window.unaProductShippingReady)
      .catch(function () {})
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        window.location.assign('/checkout');
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.removeAttribute('data-una-buy-now-loading');
        button.removeAttribute('data-una-buy-now-original-text');
        if (label) label.textContent = originalText;
      });
  }

  document.addEventListener('cart:item-added', function () {
    if (window.location.pathname.indexOf('/products/') === 0) {
      goToCart();
    }
  });

  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant && variant.price != null) {
      window.unaSelectedVariantPrice = Number(variant.price);
      document.dispatchEvent(new CustomEvent('una:product-price-change'));
    }

    document.querySelectorAll('[data-una-buy-now]').forEach(function (button) {
      var unavailable = variant && variant.available === false;
      var shippingBusy = document.documentElement.hasAttribute('data-una-product-shipping-busy');
      button.disabled = !!unavailable || shippingBusy;
      button.setAttribute('aria-disabled', unavailable || shippingBusy ? 'true' : 'false');
    });
  });

  document.addEventListener('product:quantity-update', function () {
    document.dispatchEvent(new CustomEvent('una:product-price-change'));
  });

  document.addEventListener('click', function (event) {
    var buyNowButton = event.target && event.target.closest && event.target.closest('[data-una-buy-now]');
    if (buyNowButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      goToCheckout(buyNowButton);
      return;
    }

    var link = event.target && event.target.closest && event.target.closest('a[href="/cart"]');
    if (!link || window.location.pathname === '/cart') return;
    if (link.closest('.quick-cart, .purchase-confirmation-popup, [class*="cart-drawer"]')) return;
    if (!link.closest('header, .header, [data-section-type="header"]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    goToCart();
  }, true);

  window.addEventListener('pageshow', restoreBuyNowButtons);
}());
